import { EnumCellProps } from "@jsonforms/core";
import { withJsonFormsEnumCellProps } from "@jsonforms/react";
import { useMemo } from "react";

import Select from "@/components/elements/Select";

function EnumCellComponent({
  data,
  handleChange,
  path,
  enabled,
  options,
}: EnumCellProps) {
  const selectedValue = useMemo(() => {
    if (data == null) return null;
    return options?.find((opt) => opt.value === data) ?? null;
  }, [data, options]);

  return (
    <Select
      options={options ?? []}
      value={selectedValue}
      onChange={(opt: any) => handleChange(path, opt ? opt.value : undefined)}
      disabled={!enabled}
    />
  );
}

export const EnumCell = withJsonFormsEnumCellProps(EnumCellComponent);
